import React, { useMemo } from 'react';
import { AcademyPortalDataContext } from '../../contexts/academyPortalData';
import { useMyPlayerLive, useGroupsLive, useHiddenGroupIdsLive } from '../../hooks/useGroups';
import { useConversationsLive } from '../../hooks/useConversations';
import { useAcademyLive } from '../../hooks/useAcademy';

// See contexts/academyPortalData.js. Must sit inside SelectedProgramProvider
// (a coach's groups are narrowed to the selected program).
export default function AcademyPortalDataProvider({ children }) {
  const myPlayer = useMyPlayerLive(true);
  const groups = useGroupsLive(true);
  const conversations = useConversationsLive(true);
  const academy = useAcademyLive(true);
  const hiddenGroupIds = useHiddenGroupIdsLive(true);

  const myPlayerValue = useMemo(() => myPlayer, [myPlayer.player, myPlayer.loading, myPlayer.isPrimaryGuardian]); // eslint-disable-line react-hooks/exhaustive-deps
  const groupsValue = useMemo(() => groups, [groups.groups, groups.loading]); // eslint-disable-line react-hooks/exhaustive-deps
  const conversationsValue = useMemo(() => conversations, [conversations.conversations, conversations.loading]); // eslint-disable-line react-hooks/exhaustive-deps
  const academyValue = useMemo(() => academy, [academy.academy, academy.loading]); // eslint-disable-line react-hooks/exhaustive-deps

  const value = useMemo(() => ({
    myPlayer: myPlayerValue,
    groups: groupsValue,
    conversations: conversationsValue,
    academy: academyValue,
    hiddenGroupIds,
  }), [myPlayerValue, groupsValue, conversationsValue, academyValue, hiddenGroupIds]);

  return <AcademyPortalDataContext.Provider value={value}>{children}</AcademyPortalDataContext.Provider>;
}
